import React from 'react';
import { FormControl, FormHelperText, FormLabel, TextField } from '@mui/material';
import { canUseRichText } from '../../lib/userRoleHierarchy';
import { resolveRichTextEnabled } from '../../lib/richText';
import TicketRichTextEditor from './TicketRichTextEditor';
import RichTextDisplay from './RichTextDisplay';

/**
 * Role + preference gated field: rich editor or plain textarea.
 * @param {{
 *   label: string,
 *   value: string,
 *   onChange: (value: string) => void,
 *   userData?: object,
 *   ticketId?: string | null,
 *   disabled?: boolean,
 *   minRows?: number,
 *   helperText?: string,
 *   placeholder?: string,
 * }} props
 */
export default function TicketRichTextField({
  label,
  value,
  onChange,
  userData,
  ticketId = null,
  disabled = false,
  minRows = 3,
  helperText,
  placeholder,
}) {
  const rich = canUseRichText(userData?.role) && resolveRichTextEnabled(userData);

  if (rich && disabled) {
    return (
      <FormControl fullWidth>
        <FormLabel sx={{ mb: 0.75, fontSize: '0.875rem' }}>{label}</FormLabel>
        <RichTextDisplay body={value} bodyFormat="html" />
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    );
  }

  if (rich) {
    return (
      <FormControl fullWidth disabled={disabled}>
        <FormLabel sx={{ mb: 0.75, fontSize: '0.875rem' }}>{label}</FormLabel>
        <TicketRichTextEditor
          value={value}
          onChange={onChange}
          disabled={disabled}
          minHeight={minRows * 28}
          placeholder={placeholder || 'Write something…'}
          ticketId={ticketId}
        />
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    );
  }

  return (
    <TextField
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      multiline
      minRows={minRows}
      disabled={disabled}
      helperText={helperText}
      placeholder={placeholder}
    />
  );
}
